export const openInNew = require("assets/v1.1/icons/Core/OpenInNew/outline.svg") + "#outline";
